module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/ai378-e6a5a55cfaaa8ca2c804bdcbd0fc9b2c.jpg";